import { useEffect, useRef } from "react";

const EMPTY_FAVICON =
  "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";

export function useTemporaryFavicon(active: boolean) {
  const originalIcons = useRef<HTMLLinkElement[]>([]);

  useEffect(() => {
    const icons = Array.from(
      document.querySelectorAll<HTMLLinkElement>(
        'link[rel~="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]'
      )
    );

    if (active) {
      if (originalIcons.current.length === 0) {
        originalIcons.current = icons.map((icon) => icon.cloneNode(true) as HTMLLinkElement);
      }

      // remove all existing
      icons.forEach((icon) => icon.remove());

      // inject empty favicon
      const emptyIcon = document.createElement("link");
      emptyIcon.rel = "icon";
      emptyIcon.href = EMPTY_FAVICON;
      emptyIcon.setAttribute("data-temp-favicon", "true");
      document.head.appendChild(emptyIcon);
    } else {
      // remove temp favicon
      document
        .querySelectorAll('link[data-temp-favicon]')
        .forEach((n) => n.remove());

      // restore originals
      originalIcons.current.forEach((icon) =>
        document.head.appendChild(icon)
      );
      originalIcons.current = [];
    }
  }, [active]);
}
